module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1240.275a7413.png";